import { useState, useMemo } from 'react';
import { getMyPurchaseFilterTab, setMyPurchaseFilterTab } from '_utils/localData';
import resolvePurchaseCardState from '../helper.js/resolvePurchaseCardState';
import { PURCHASE_STATUS } from '../constant/constant';

export const FILTER_TABS = {
  ALL: 'All',
  ACTIVE: 'Active',
  VERIFIED: 'Verified',
  UNPAID: 'Unpaid',
  PENDING: 'Pending',
  COLLECTED: 'Collected',
  CANCEL: 'Cancel',
  REFUND: 'Refund',
};

const normalizeString = (str = '') => str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export default function useFilterBar(myOrders) {
  const [activeTab, setActiveTabState] = useState(() => {
    const savedTab = getMyPurchaseFilterTab();
    if (savedTab && Object.values(FILTER_TABS).includes(savedTab)) {
      return savedTab;
    }
    return FILTER_TABS.ACTIVE;
  });
  const [searchTerm, setSearchTerm] = useState('');

  const setActiveTab = (tab) => {
    setActiveTabState(tab);
    setMyPurchaseFilterTab(tab);
  };

  const filteredOrders = useMemo(() => {
    if (!myOrders || !myOrders.length) return [];

    let result = myOrders;

    switch (activeTab) {
      case FILTER_TABS.ACTIVE:
        result = myOrders.filter((order) => {
          const { status, isDisable } = resolvePurchaseCardState(order);
          return (
            !isDisable &&
            status !== PURCHASE_STATUS.CANCEL &&
            status !== PURCHASE_STATUS.REFUND
          );
        });
        break;
      case FILTER_TABS.VERIFIED:
        result = myOrders.filter((order) => {
          const { isVerified, status } = resolvePurchaseCardState(order);
          return isVerified || status === PURCHASE_STATUS.READY
            || status === PURCHASE_STATUS.FULFILL
            || status === PURCHASE_STATUS.VERIFIED;
        });
        break;
      case FILTER_TABS.UNPAID:
        result = myOrders.filter((order) => {
          const { status } = resolvePurchaseCardState(order);
          return status === PURCHASE_STATUS.UNPAID;
        });
        break;
      case FILTER_TABS.PENDING:
        result = myOrders.filter((order) => {
          const { status } = resolvePurchaseCardState(order);
          return status === PURCHASE_STATUS.PENDING;
        });
        break;
      case FILTER_TABS.COLLECTED:
        result = myOrders.filter((order) => {
          const { status } = resolvePurchaseCardState(order);
          return status === PURCHASE_STATUS.COLLECTED;
        });
        break;
      case FILTER_TABS.CANCEL:
        result = myOrders.filter((order) => {
          const { status } = resolvePurchaseCardState(order);
          return status === PURCHASE_STATUS.CANCEL;
        });
        break;
      case FILTER_TABS.REFUND:
        result = myOrders.filter((order) => {
          const { status } = resolvePurchaseCardState(order);
          return status === PURCHASE_STATUS.REFUND;
        });
        break;
      case FILTER_TABS.ALL:
      default:
        result = myOrders;
        break;
    }

    if (searchTerm && searchTerm.trim()) {
      const normalizedKeyword = normalizeString(searchTerm);
      result = result.filter((order) =>
        normalizeString(order?.eTitle || '').includes(normalizedKeyword));
    }

    return result;
  }, [myOrders, activeTab, searchTerm]);

  return {
    filteredOrders,
    activeTab,
    setActiveTab,
    searchTerm,
    setSearchTerm,
  };
}
